import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Register.css';
import logo from './sindikat_new.jpg';

export const Register = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [repeatPass, setRepeatPass] = useState('');
    const [name, setName] = useState('');
    const [prezime, setPrezime] = useState('');
    const [datRod, setDatRod] = useState('');
    const [adresa, setAdresa] = useState('');
    const [oib, setOib] = useState('');
    const [mobitel, setMobitel] = useState('');
    const [ustanovaRada, setUstanovaRada] = useState('');

    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    function isOibValid(input) {
        const oib = input.toString();
        if (oib.match(/\d{11}/) === null) return false;

        let calculated = 10;

        for (const digit of oib.substring(0, 10)) {
            calculated += parseInt(digit);
            calculated %= 10;
            if (calculated === 0) calculated = 10;
            calculated *= 2;
            calculated %= 11;
        }

        let check = 11 - calculated;
        if (check === 10) check = 0;

        return check === parseInt(oib[10]);
    }

    const handleSubmit = (e) => e.preventDefault();

    function registerClan() {
        if (!name || !prezime || !datRod || !adresa || !oib || !email || !mobitel || !ustanovaRada || !pass || !repeatPass) {
            toast("Sva polja su obavezna");
            return;
        }

        if (mobitel.charAt(0) !== '0' || mobitel.charAt(1) !== '9' || mobitel.length < 9 || mobitel.length > 10) {
            toast("Broj mobitela nije u ispravnom formatu");
        } else if (pass !== repeatPass) {
            toast("Upisane lozinke nisu iste");
        } else if (!isOibValid(oib)) {
            toast("OIB nije u ispravnom formatu");
        } else if (!validateEmail(email)) {
            toast("E-mail nije u ispravnom formatu");
        } else {
            const datumRodenja = datRod.split("-").join("-");
            fetch("https://sind-zajedno.times.hr/registerclanovi", {
                method: 'POST',
                body: JSON.stringify({
                    ime: name,
                    prezime: prezime,
                    datum: datumRodenja,
                    adresa,
                    oib,
                    email,
                    mobitel,
                    ustanovaRada,
                    sifra: pass,
                    aktivacija: 'N',
                    kartica: '1234'
                }),
                headers: {
                    "Content-Type": "application/json;charset=UTF-8"
                }
            })
                .then((response) => {
                    if (!response.ok) throw Error(response.statusText);
                    return response.text();
                })
                .then((response) => toast(response))
                .catch(err => console.log(err));
        }
    }

    return (
        <div className="modern-form">
            <form className="register-form" onSubmit={handleSubmit}>
                <img src={logo} className="App-logo" alt="logo" />
                <h2 className="form-title">Registracija člana</h2>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="name">Ime</label>
                        <input
                            value={name}
                            name="name"
                            onChange={(e) => setName(e.target.value)}
                            id="name"
                            placeholder="Vaše ime"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="prezime">Prezime</label>
                        <input
                            value={prezime}
                            name="prezime"
                            onChange={(e) => setPrezime(e.target.value)}
                            id="prezime"
                            placeholder="Vaše prezime"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="datRod">Datum rođenja</label>
                        <input
                            value={datRod}
                            name="datRod"
                            type="date"
                            onChange={(e) => setDatRod(e.target.value)}
                            id="datRod"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="oib">OIB</label>
                        <input
                            value={oib}
                            onChange={(e) => setOib(e.target.value)}
                            name="oib"
                            type="number"
                            id="oib"
                            placeholder="12345678901"
                        />
                    </div>
                </div>

                <label htmlFor="adresa">Adresa</label>
                <input
                    value={adresa}
                    onChange={(e) => setAdresa(e.target.value)}
                    id="adresa"
                    placeholder="Vaša adresa"
                />

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="email">E-mail</label>
                        <input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            id="email"
                            name="email"
                            placeholder="your@email.com"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="mobitel">Mobitel</label>
                        <input
                            value={mobitel}
                            onChange={(e) => setMobitel(e.target.value)}
                            id="mobitel"
                            type="tel"
                            placeholder="091234567"
                        />
                    </div>
                </div>

                <label htmlFor="ustanovaRada">Ustanova rada</label>
                <input
                    value={ustanovaRada}
                    onChange={(e) => setUstanovaRada(e.target.value)}
                    id="ustanovaRada"
                    placeholder="Naziv vaše ustanove"
                />

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="password">Lozinka</label>
                        <input
                            value={pass}
                            onChange={(e) => setPass(e.target.value)}
                            type="password"
                            id="password"
                            name="password"
                            placeholder="********"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="repeatPass">Ponovite lozinku</label>
                        <input
                            value={repeatPass}
                            onChange={(e) => setRepeatPass(e.target.value)}
                            type="password"
                            id="repeatPass"
                            name="repeatPass"
                            placeholder="********"
                        />
                    </div>
                </div>

                <div className="button-group">
                    <button type="button" className="btn btn-primary" onClick={registerClan}>
                        Registracija
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={() => navigate('/')}>
                        Prijava
                    </button>
                </div>

                <ToastContainer />
            </form>
        </div>
    );
};
